<template>
    <div v-if="events.length > 0">
        <h5>{{transEdit('events')}}</h5>
        <div v-for="event in events" class="border rounded p-1 mt-1 pl-1 pr-1">
            <template v-if="event.type_id == 1">
                <div class="d-flex align-items-center">
                    <div class="flex-shrink-1 mr-2 "><span class="text-black-50">{{getFormattedDate(event.event_data.updated_at)}}</span></div>
                    <div class="flex-1"><strong>{{getDescriptor(event.type_id)}}</strong></div>
                    <div class="flex-1"><strong>{{event.event_data.user.name}}</strong></div>
                    <div>
                        <a :href="event.display_route" class="d-flex align-items-center p-1 pl-2 pr-2 btn btn-sm btn-outline-primary flex-1">
                            <i class="d-flex fa fa-user align-items-center"></i> {{transEdit('show-cv')}}
                        </a>
                    </div>
                </div>

            </template>

            <template v-else>
                Okänd händelsetyp
            </template>
        </div>
        <hr>
    </div>
</template>

<script>
    let descriptorArray = [
        'Ny terapeut',
    ];
    //Event_ids:
    //1: newly registered therapist
    export default {
        props: ['part'],
        name: "admin-dash-events-panel",
        data: function () {
            return {
                events: [],
            };
        },
        methods: {
            getFormattedDate: function(date) {
                let _date = new moment(date);
                return _date.format('YYYY-MM-DD');
            },
            getDescriptor: function(type_id) {
                return descriptorArray[type_id - 1];
            },
        },
        mounted: function () {
            let self = this;
            axios.get(this.part.route_refresh)
                .then(function (response) {
                    self.events = response.data.events;
                })
                .catch(function (error) {
                });
        }
    }

</script>

<style scoped>

</style>
